/**
 * hide any other element on the page, that is not the download-center
 */
export const hideOtherPageElements = (smooth?: boolean) => {
  const nonDownloadCenter = window.$('.item:not(.item--UR2DownloadCenter)')

  if (smooth === true) {
    nonDownloadCenter.slideUp(() => {
      window.scrollTo(0, 0)
    })
  } else {
    nonDownloadCenter.hide()
    window.scrollTo(0, 0)
  }
}

/**
 * show any other element on the page, that is not the download-center
 */
export const showOtherPageElements = () => {
  const nonDownloadCenter = window.$('.item:not(.item--UR2DownloadCenter)')
  nonDownloadCenter.show()
}
